import { Box } from "@mui/material";
//import { services } from "data";
import { services } from "../../data";
import ServicesList from "./services";
import ServiceDetails from "./serviceDetails";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

export default function ComponentServices() {

  const selectedService = useSelector((state: RootState)=>state.service.value);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <ServicesList />
      <ServiceDetails service={services[selectedService]} />
    </Box>
  );
}
